import { ReservationType } from '../../../types/reservationType';

interface PanelActionsInput {
  isCreating: boolean;
  isEditing: boolean;
  isCanceled: boolean;
  isBlocked: boolean;
  isPast: boolean;
  hasStarted: boolean;
  isUnregisteredClient: boolean;
  isAttendanceMode: boolean;
  reservationType: ReservationType | undefined;
}

/** What the delete button of the panel does: open the attendance mode, cancel or delete the reservation, or nothing. */
type DeleteAction = 'attendance' | 'delete' | undefined;
/** What the save button of the panel does: register the attendance, save the reservation, or nothing. */
type SaveAction = 'attendance' | 'save' | 'none';

/** Which buttons the reservation panel shows and what its save and delete buttons do, for one reservation state. */
export const getPanelActions = ({
  isCreating,
  isEditing,
  isCanceled,
  isBlocked,
  isPast,
  hasStarted,
  isUnregisteredClient,
  isAttendanceMode,
  reservationType,
}: PanelActionsInput) => {
  let deleteAction: DeleteAction;
  if (!isCreating && !isEditing && !isCanceled && !isBlocked) {
    deleteAction = hasStarted && !isUnregisteredClient ? 'attendance' : 'delete';
  }

  let saveAction: SaveAction;
  if (isEditing && !isCanceled && hasStarted) {
    saveAction = isAttendanceMode ? 'attendance' : 'save';
  } else {
    saveAction = !isCanceled ? 'save' : 'none';
  }

  return {
    deleteAction,
    saveAction,
    hideEditButton: isCanceled || isBlocked || (isPast && !(reservationType?.groupSize === 1 && !isAttendanceMode)),
    hideDeleteButton: (isPast && !isUnregisteredClient) || isBlocked,
    showAttendanceButton: !!reservationType?.hasAttendance && !isUnregisteredClient && !isCanceled && isPast && !isBlocked,
    showCloneButton: !isCreating && !isEditing && !isCanceled && !!reservationType?.isCloneable && !isBlocked,
    showBlockButton: isCreating && !isEditing && !!reservationType?.canBeBlocked,
    showUnblockButton: !isCreating && !isEditing && isBlocked,
  };
};
